
import { Component, Vue, Prop } from "vue-property-decorator";
import { plainToInstance } from "class-transformer";

import unit_routes from "@/api/routes/units";

import { phases } from "@/consts";

import ImageView from "@/components/ImageView.vue";
import CAudioView from "@/components/audioView.vue";
import VideoView from "@/components/VideoView.vue";
import CFileDownload from "@/components/FileDownload.vue";

import RelationVersion from "@/models/relation/version";
import UnitVersion, { EUnitableType } from "@/models/unit/unit_version";
import DocumentVersion from "@/models/unit/unitable/document/version";
import UnitUnit from "@/models/unit/unit";

@Component({
  name: "CProgramMaterialDocument",
  components: {
    CFileDownload,
    ImageView,
    CAudioView,
    VideoView
  }
})
export default class CProgramMaterialDocument extends Vue {
  @Prop({ required: true }) program_id!: string;
  @Prop({ required: true }) relation!: RelationVersion;
  @Prop({ required: false, default: false }) public disabled!: boolean;

  public phases = phases.slice(1, 5);
  public unit_version: UnitVersion | null = null;

  private edit_errors: string | null = null;

  protected async created() {
    await this.loadDocument();
  }

  public changeFormat(type: string | null) {
    (this.unit_version!.unitable as DocumentVersion).file_type = type
      ? type
      : (this.unit_version!.unitable as DocumentVersion).url.split(".").pop()!;
  }

  public async loadDocument() {
    if (this.relation.unit_version_id) {
      return this.$api
        .get(unit_routes.version(this.relation.unit_version_id))
        .then(({ data: res }: { data: UnitVersion }) => {
          this.unit_version = plainToInstance(UnitVersion, res);
        });
    } else {
      this.unit_version = new UnitVersion({
        relation_version: this.relation,
        unit: new UnitUnit({ is_template: false }),
        unitable: new DocumentVersion(),
        unitable_type: EUnitableType["Document::Version"]
      });

      this.unit_version!.title = "Документ-ссылка на Digital Library";
    }
  }

  public unitable() {
    return this.unit_version?.unitable as DocumentVersion;
  }

  public async createDocument() {
    return this.$api
      .post(unit_routes.versions, {
        ...this.unit_version,
        ...{
          relation: { program_id: this.program_id }
        }
      })
      .then(({ data: res }: { data: RelationVersion }) => {
        this.$emit("relationCreated", res);
      })
      .catch(({ response: res }) => {
        this.edit_errors = res.data.error;
      });
  }

  public async updateDocument() {
    if (
      !window.confirm(
        "Вы уверены, что хотите сохранить новую редакцию материала?"
      )
    ) {
      return;
    }

    this.$api
      .put(unit_routes.version(this.unit_version!.id), {
        ...this.unit_version,
        ...{
          relation_version: { id: this.relation.id, level: this.relation.level }
        }
      })
      .then(({ data: res }: { data: RelationVersion }) => {
        this.$emit("relationUpdated", res);
      })
      .catch(({ response: res }) => {
        this.edit_errors = res.data.error;
      });
  }
}
